/* eslint-disable react-hooks/exhaustive-deps */
import {
  ArrowCircleRight,
  ArrowCircleLeft,
  Add,
  Delete,
  AttachFile,
} from "@mui/icons-material";
import {
  Button,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useCallback, useRef, useState } from "react";
import { useDrop } from "react-dnd";

import { useFieldArray } from "react-hook-form";
import { NativeTypes } from "react-dnd-html5-backend";

const useStyles = makeStyles((theme) => ({
  ImageFieldRoot: {
    height: "100%",
    width: "100%",
  },
  ImageFieldEmpty: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  ImageFieldGallery: {
    height: "100%",
    width: "100%",
    position: "relative",
    backgroundColor: "red",
  },

  ImageFieldGalleryPreview: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    backgroundColor: "black",
  },
  ImageFieldGalleryButton: (props) => ({
    position: "absolute !important",
    display: "block",
    top: "50%",
    [props.side]: "0%",
  }),
  ImageFieldMiniGallery: {
    height: "120px",
    position: "absolute",
    maxWidth: "100%",
    display: "flex",
    overflow: "auto",
    gap: theme.spacing(1),
    borderRadius: "9px",
    backgroundColor: "rgba(0,0,0,0.8)",
    bottom: "0",
    padding: theme.spacing(2),
  },
  ImageFieldMiniGalleryAddButton: {
    aspectRatio: "1 / 1",
    height: "100%",
    width: "auto",
    borderRadius: "100%",
    border: `1px solid ${theme.palette.grey["600"]}`,
    color: theme.palette.grey["600"],
  },
  ImageFieldMiniGalleryPreviewWrapper: {
    aspectRatio: "1 / 1",
    height: "100%",
    width: "auto",
    position: "relative",
    "& > img": {
      height: "100%",
      width: "100%",
      objectFit: "cover",
    },
    "& > button": {
      position: "absolute",
      backgroundColor: "rgba(0,0,0,0.4)",
      height: "20px",
      width: "20px",
      top: theme.spacing(1),
      right: theme.spacing(1),
    },
  },
}));

export function ImageFieldGallery({
  imageSrcs,
  onDeleteItem,
  fileInputRef,
  canDeleteImage = () => true,
}) {
  const classes = useStyles();
  const [currentImage, setCurrentImage] = useState(0);

  const handleClickNext = () => {
    setCurrentImage((prev) => prev + 1);
  };
  const handleClickPrevious = () => {
    setCurrentImage((prev) => prev - 1);
  };

  const showNextButton = () => {
    return currentImage + 1 !== imageSrcs.length;
  };

  const showPreviousButton = () => {
    return currentImage !== 0;
  };

  const showPreviewDeleteButton = (index) => {
    return canDeleteImage(index) && index === currentImage;
  };

  const handleSelectImage = (index) => () => {
    setCurrentImage(index);
  };

  const handleClickDelete = (index) => (e) => {
    e.stopPropagation();
    onDeleteItem(index);
    if (index > 0) {
      setCurrentImage(index - 1);
    }
  };

  const handleClickAddImage = () => {
    fileInputRef.current.click();
  };

  console.log({ currentImage });
  return (
    <div className={classes.ImageFieldGallery}>
      <img
        src={imageSrcs[currentImage]}
        className={classes.ImageFieldGalleryPreview}
        alt="inputed"
      />
      {showPreviousButton() && (
        <IconButton
          onClick={handleClickPrevious}
          className={classes.ImageFieldGalleryButton}
          sx={{ left: "0%" }}
        >
          <ArrowCircleLeft />
        </IconButton>
      )}
      {showNextButton() && (
        <IconButton
          onClick={handleClickNext}
          className={classes.ImageFieldGalleryButton}
          sx={{ right: "0%" }}
        >
          <ArrowCircleRight color={"none"} />
        </IconButton>
      )}

      <div className={classes.ImageFieldMiniGallery}>
        {imageSrcs.map((imageSrc, index) => {
          return (
            <div
              className={classes.ImageFieldMiniGalleryPreviewWrapper}
              onClick={handleSelectImage(index)}
            >
              <img src={imageSrc} alt="" />
              {showPreviewDeleteButton(index) && (
                <IconButton onClick={handleClickDelete(index)}>
                  <Delete />
                </IconButton>
              )}
            </div>
          );
        })}
        <button
          className={classes.ImageFieldMiniGalleryAddButton}
          onClick={handleClickAddImage}
          type="button"
        >
          <Add />
        </button>
      </div>
    </div>
  );
}

export default function ImageField({
  multiple,
  maxItems = 2,
  formMethods,
  fieldName,
  ...rest
}) {
  const theme = useTheme();
  const isDisplaySmall = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();
  const { fields, append, remove, replace } = useFieldArray({
    control: formMethods.control,
    name: fieldName,
  });

  const value = formMethods.watch(fieldName);

  const handleItemsDrop = useCallback(
    (item) => {
      if (item) {
        const files = Array.from(item.files);

        if (multiple) {
          append(files);
        } else {
          replace([files[0]]);
        }
      }
    },
    [fields]
  );

  const handleDeleteFile = useCallback(
    (deletedItemIndex) => {
      remove(deletedItemIndex);
    },
    [fields]
  );

  // eslint-disable-next-line no-empty-pattern
  const [{}, drop] = useDrop(
    () => ({
      accept: [NativeTypes.FILE],
      drop(item) {
        handleItemsDrop(item);
      },
      canDrop(item) {
        return true;
      },
      hover(item) {},
      collect: (monitor) => {
        const item = monitor.getItem();
        if (item) {
        }
        return {
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop(),
        };
      },
    }),
    [rest]
  );

  const fileInputRef = useRef();
  const handleChange = (event) => {
    handleItemsDrop({ files: event.target.files });
  };

  const handleClickAddImage = () => {
    fileInputRef.current.click();
  };
  const displayImageList = () => {
    return !!value.length;
  };
  const imageURLs = value.map((file) => {
    return URL.createObjectURL(file);
  });
  return (
    <div className={classes.ImageFieldRoot}>
      <input
        id="image_upload_input"
        ref={fileInputRef}
        onChange={handleChange}
        multiple={multiple}
        type="file"
        accept="image/*"
        hidden
      />
      {displayImageList() ? (
        <ImageFieldGallery
          imageSrcs={imageURLs}
          onDeleteItem={handleDeleteFile}
          fileInputRef={fileInputRef}
        />
      ) : (
        <div ref={drop} className={classes.ImageFieldEmpty}>
          <span className="flex flex-col items-center gap-2">
            <AttachFile
              sx={{ fontSize: "4.5rem", color: theme.palette.primary }}
              color="primary"
            />
            {!isDisplaySmall && (
              <Typography variant="caption">
                Arraste e solte imagens aqui
              </Typography>
            )}
            <Button onClick={handleClickAddImage} variant="contained">
              Selecionar {isDisplaySmall ? `da galeria` : `do computador`}
            </Button>
          </span>
        </div>
      )}
    </div>
  );
}
